import {apiGPT} from "./configUrl.jsx"

export async function callGPT(token, question) {
  try {
    const response = await fetch(apiGPT, {  // URL backend bạn đổi nếu khác
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`,
      },
      body: JSON.stringify({ question }),
    });

    if (!response.ok) return false;

    const data = await response.json();
    return data; // { question, answer }
  } catch {
    return false;
  }
}
